/**
 * Hook to retrieve property owner information.
 */

import { useCallback, useState } from 'react';
import api from '../api';
import { IOwner } from '../ts/interfaces/Owner';

const usePropertyOwner = () => {
  const [owner, setOwner] = useState<IOwner | undefined>(undefined);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  const onResetGetPropertyOwner = useCallback(() => {
    setOwner(undefined);
    setIsLoading(false);
    setError(null);
  }, []);

  const onGetPropertyOwner = useCallback(
    async (propertyId: string) => {
      setIsLoading(true);
      setError(null);
      try {
        const response = await api.getPropertyOwner(propertyId);
        setOwner(response);
      } catch (err) {
        setError((err as Error).message);
      } finally {
        setIsLoading(false);
      }
    },
    [setOwner]
  );

  return {
    owner,
    isLoading,
    error,
    onGetPropertyOwner,
    onResetGetPropertyOwner
  };
};

export default usePropertyOwner;
